<template>
  <div>
    <pix-title-loader class="pix-title-loader" />
    <price-card :full-value="null" :due-date="null" />
    <caption-loader class="z-caption spacer-bottom-s" />
    <pix-qr-code-loader class="payment-code" />
    <div class="row">
      <div class="col-md-6">
        <button-loader class="spacer-bottom-m" />
      </div>
      <div class="col-md-6">
        <button-loader />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.pix-title-loader,
.payment-code {
  margin-bottom: var(--space-extra-large);
}
</style>

<script>
import PixQrCodeLoader from 'content-loaders/pix/pix-qr-code-loader';
import PixTitleLoader from 'content-loaders/pix/pix-title-loader';
import ButtonLoader from 'content-loaders/button-loader';
import CaptionLoader from 'content-loaders/caption-loader';
import PriceCard from 'components/price-card';

export default {
  components: {
    PixQrCodeLoader,
    PixTitleLoader,
    ButtonLoader,
    CaptionLoader,
    PriceCard,
  },
};
</script>
